import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Gift } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { useAuth } from '@/contexts/AuthContext';
import API_URL from '@/config/api';

const KEY = 'voucher-prompt-shown';

/** Shown once per login session to trainees who still have an unclaimed Google-review voucher. */
export default function VoucherPrompt() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!user || user.role !== 'installer' || sessionStorage.getItem(KEY)) return;
    fetch(`${API_URL}/api/vouchers`, { credentials: 'include' }).then((r) => (r.ok ? r.json() : null)).then((d) => { if (d?.prompt) setData(d); }).catch(() => {});
  }, [user]);

  if (!data) return null;
  const dismiss = () => { sessionStorage.setItem(KEY, '1'); setData(null); };
  const amount = Number(data.totals?.locked || 0);

  return (
    <Dialog open onOpenChange={(o) => !o && dismiss()}>
      <DialogContent className="max-w-md p-0 overflow-hidden" data-testid="voucher-prompt">
        <div className="bg-[#27292E] text-white px-6 pt-8 pb-6 text-center">
          <div className="w-16 h-16 mx-auto rounded-2xl bg-amber-400 text-[#27292E] flex items-center justify-center mb-4 animate-bounce"><Gift className="w-8 h-8" /></div>
          <p className="text-lg font-bold leading-snug" data-testid="voucher-prompt-text">{data.prompt_text}</p>
          {amount > 0 && <p className="text-amber-300 font-extrabold text-3xl mt-3">£{amount.toLocaleString('en-GB', { maximumFractionDigits: 0 })} of vouchers waiting</p>}
        </div>
        <div className="p-5 space-y-2">
          <Button onClick={() => { dismiss(); navigate('/vouchers'); }} className="w-full bg-amber-500 hover:bg-amber-600 text-[#27292E] font-bold rounded-full h-11" data-testid="voucher-prompt-go">Review my vouchers</Button>
          <Button variant="ghost" onClick={dismiss} className="w-full text-gray-500" data-testid="voucher-prompt-later">Maybe later</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
